import { render, staticRenderFns } from "./StepEmail.vue?vue&type=template&id=2056cc90&"
import script from "./StepEmail.vue?vue&type=script&lang=js&"
export * from "./StepEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports